import type { Player } from '@dicetechnology/doris-core';
import { isGooglePalPlugin } from '@dicetechnology/doris-plugin-google-pal';
import type { cast as castNs } from 'chromecast-caf-receiver';

import { DiceReceiverManager } from '../services';

declare const cast: typeof castNs;

export const configureGooglePalPlugin = async (player: Player): Promise<void> => {
    const GOOGLE_PAL_PLUGIN_NAME = 'google-pal';

    const diceReceiverManager = DiceReceiverManager.getInstance();
    const googlePalManager = diceReceiverManager.getGooglePalManager();
    // If the plugin is not yet added, only proceed if GooglePAL is enabled
    if (!googlePalManager?.getIsEnabled() || player.getPluginByName(GOOGLE_PAL_PLUGIN_NAME)) {
        return;
    }

    const { advertisingId } = await diceReceiverManager.getUserDetails();
    googlePalManager.setAdvertisingId(advertisingId);

    const { GooglePalPlugin } = await import('@dicetechnology/doris-plugin-google-pal');
    const existingPlugin = player.getPluginByType(GooglePalPlugin);
    if (!existingPlugin) {
        player.addPlugin({
            name: GOOGLE_PAL_PLUGIN_NAME,
            Plugin: GooglePalPlugin
        });
    }

    const castContext = cast.framework.CastReceiverContext.getInstance();
    const playerManager = castContext.getPlayerManager();

    // Register any interactions with the player for AdTouch
    const interactionEvents = [
        cast.framework.events.EventType.REQUEST_SEEK,
        cast.framework.events.EventType.REQUEST_STOP,
        cast.framework.events.EventType.REQUEST_PAUSE,
        cast.framework.events.EventType.REQUEST_PLAY,
        cast.framework.events.EventType.REQUEST_SKIP_AD,
        cast.framework.events.EventType.REQUEST_PLAY_AGAIN,
        cast.framework.events.EventType.REQUEST_PLAYBACK_RATE_CHANGE,
        cast.framework.events.EventType.REQUEST_VOLUME_CHANGE,
        cast.framework.events.EventType.REQUEST_USER_ACTION,
        cast.framework.events.EventType.REQUEST_FOCUS_STATE
    ];
    playerManager.addEventListener(interactionEvents, (interactionEvent) => {
        player.findPlugin(isGooglePalPlugin)?.sendAdTouch(interactionEvent);
    });
};
